<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "ZupanijaBase"
};
</script>

<style scoped>

</style>
